<template>
  <div class="dialog-component" :class="`${dialogType}-dialog`" @click.stop="">
    <van-popup v-model="show">
      <component :is="dialogType | typeToComponentName" @closeDialog="closeDialog" />
    </van-popup>
  </div>
</template>

<script>
import GroupBuySuccessDialog from '@/pages/courseDetail/courseActivity/groupBuy/GroupBuySuccessDialog.vue';
import downloadApp from './downloadApp.vue';

export default {
  name: 'dialogComponent',
  components: { downloadApp, GroupBuySuccessDialog },
  props: {
    dialogType: {
      type: String,
      default: 'downloadApp',
    },
  },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === 'downloadApp') {
        componentName = 'downloadApp';
      } else if (val === 'groupBuySuccessDialog') {
        componentName = 'GroupBuySuccessDialog';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    closeDialog() {
      this.show = !this.show;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-component {
  ::v-deep .van-popup {
    z-index:10000 !important;
    border-radius: 14px;
  }
}
.groupBuySuccessDialog-dialog {
  ::v-deep .van-popup {
    border-radius: 6px;
  }
}
</style>
